import { HelperTexts } from '../types';

export const getHelperTexts = (
  jobData:
    | {
        breakMinutes: number;
        hourlyRateCents: number | undefined;
      }
    | undefined
): HelperTexts => {
  if (!jobData) {
    return {
      hourlyRate: undefined,
      breakMinutes: undefined,
    };
  }
  const { breakMinutes } = jobData;
  const result: HelperTexts = {
    breakMinutes: `De standaard voor deze functie is ${breakMinutes} min`,
  };
  if (jobData.hourlyRateCents) {
    result.hourlyRate = `De standaard voor deze functie is € ${(jobData.hourlyRateCents || 0) / 100}`;
  }
  return result;
};
